import defaultConfig from '../../config/default.js'

const localModules = import.meta.glob('../../config/local.js', {
  eager: true,
  import: 'default',
})
const localConfig = Object.values(localModules)[0] || {}

function merge(base, override) {
  const merged = { ...base }
  for (const [key, value] of Object.entries(override)) {
    if (
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      typeof merged[key] === 'object' &&
      merged[key] !== null
    ) {
      merged[key] = merge(merged[key], value)
    } else {
      merged[key] = value
    }
  }
  return merged
}

const config = merge(defaultConfig, localConfig)

export const API_BASE_URL = config.api.baseURL
export const API_TIMEOUT = config.api.timeout
export const API_KEY = config.api.apiKey

export default config
